import { render } from "./MenuNestedItem.vue?vue&type=template&id=5641b466&scoped=true"
import script from "./MenuNestedItem.vue?vue&type=script&lang=js"
export * from "./MenuNestedItem.vue?vue&type=script&lang=js"

import "./MenuNestedItem.vue?vue&type=style&index=0&id=5641b466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641b466"]])

export default __exports__